import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  savedEvent?: core.TicketType;
  savedEventTemplate?: core.EventTemplate;
  savedBusinessInfo: {
    webUrl?: string;
    phone?: string;
    phoneCountryCode?: string;
  };
}

const initialState: State = {
  savedEvent: undefined,
  savedEventTemplate: undefined,
  savedBusinessInfo: {},
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.SELF_ONBOARDING_CREATE_EVENT:
      return {
        ...state,
        savedEvent: payload.savedEvent,
      };
    case AppConstants.SELF_ONBOARDING_SAVE_EVENT_TEMPLATE:
      return {
        ...state,
        savedEventTemplate: payload.savedEventTemplate,
      };
    case AppConstants.SELF_ONBOARDING_CLEAR_DATA:
      return {
        ...state,
        savedEvent: initialState.savedEvent,
        savedEventTemplate: initialState.savedEventTemplate,
        savedBusinessInfo: initialState.savedBusinessInfo,
      };
    case AppConstants.SELF_ONBOARDING_SAVE_BUSINESS_INFO:
      return {
        ...state,
        savedBusinessInfo: {
          ...payload,
        },
      };

    default: {
      return state;
    }
  }
}
